import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContainerForm } from '@/components';
import { CreateElement, VNode } from 'vue';
import { formMixins } from '@/components/SignUpForm/mixins';
import { mapActions, mapGetters } from 'vuex';
import {
  Rules,
  ISetPassFormComponent,
  ISetPassForm,
  IRegistrationTranslation,
} from '@/types';
import { VTextField } from 'vuetify/lib';
import { VuetifyInput } from '@/types';

@Component({
  name: 'SetPassForm',
  computed: {
    ...mapGetters('accounts', ['translations']),
    t(): ISetPassFormComponent { return (this.translations as IRegistrationTranslation).setPassword; },
  },
  methods: {
    ...mapActions(['showCentralAlert']),
    ...mapActions('accounts', ['sendPassword']),
  },
})
export default class SetPassForm extends Vue implements ISetPassForm {
  @Prop({type: String}) public readonly id;
  @Prop({type: String}) public readonly token;

  public email;
  public errorBucket = new Map<string, string[]>();
  public formRules: Rules = formMixins.rules;
  public sendPassword;
  public showPassword: boolean = false;
  public t!: ISetPassFormComponent;
  public rulesPassword: any[] = [];

  public password!: string;

  get form() {
    return {
      password: this.password,
    };
  }

  public validate(): boolean {
    this.errorBucket = new Map();
    const input = this.$refs.password as VuetifyInput;
    if (!input.validate(true)) {
      this.errorBucket.set('password', input.errorBucket);
    }
    return !this.errorBucket.size;
  }

  private prepareErrors(value: string) {
    this.rulesPassword = [
      this.formRules.required(
        value,
        this.$store.getters.translations.field_errors.required,
      ),
    ];
  }

  private render(createElement: CreateElement): VNode {

    const password: VNode = createElement(VTextField, {
      props: {
        autofocus: true,
        error: this.errorBucket.has('password'),
        errorMessages: this.errorBucket.get('password'),
        height: 28,
        name: 'password',
        label: this.t.passwordLabel,
        'append-icon': this.showPassword ? '$vuetify.icons.visible' : '$vuetify.icons.visible_off',
        type: this.showPassword ? 'text' : 'password',
        rules: this.rulesPassword,
      },
      attrs: {
        id: 'password',
      },
      style: {
        height: '60px',
      },
      on: {
        'click:append': () => this.showPassword = !this.showPassword,
        input: (value: string) => {
          this.password = value.trim();
          this.prepareErrors(this.password);
        },
        focus: () => this.errorBucket = new Map(),
        blur: (e) => this.prepareErrors(e.target.value),
      },
      ref: 'password',
    });

    const actionButton: VNode = createElement('button', {
      class: {
        'orange-big-button': true,
      },
      attrs: {
        type: 'submit',
      },
      on: {
        click: (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!this.validate()) { return; }
          const data = {
            id: this.id,
            token: this.token,
            password: this.password,
          };
          this.sendPassword(data).then((response) => {
            if ((response.status === 400 || response.status > 401) && response.status < 500) {
              this.errorBucket = new Map();
              const { mobile_errors } = response.data;
              this.errorBucket.set('password', mobile_errors[0].messages[0]);
            }
            if (response && response.status === 204) {
              this.$router.push({name: 'passwordResetSuccess', params: {
                title: (this as any).translations.passwordResetSuccess.title,
                text: (this as any).translations.passwordResetSuccess.message,
              }});
            }
          }).catch((error) => console.error(error));
        },
      },
    }, this.t.buttonName);

    return createElement(ContainerForm, {
      attrs: {
        id: 'set-password',
      },
      style: {
        display: 'flex',
        'justify-content': 'flex-start',
      },
      class: 'set-pass',
    }, [
      this.$slots.title,
      password,
      actionButton,
    ]);
  }
}
